<p-fieldset legend="Declaração de existência de recursos">
  <div class="row">
    <label class="required float-left col-9 col-form-label">
      Consta do procedimento declaração que atesta a existência de recursos orçamentários para a contratação?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
      [(ngModel)]="entidade.ExistenciaRecursosNao" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
  <p-fieldset legend="Fonte de recursos" *ngIf="entidade.ExistenciaRecursosNao === 'S'">
    <div class="row">
      <label class="required col-3 col-form-label">
        Valor da declaração da existência de recursos
      </label>
      <input type="text" class="col-2 form-control" [(ngModel)]="entidade.ExistenciaRecursosSim.ExistenciaRecursosValor"
        [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskConfig">
    </div>
    <div class="row">
      <label class="required col-3 col-form-label">
        Data da declaração de existência de recursos
      </label>
      <p-calendar (onFocus)="onFocusDate()"[(ngModel)]="entidade.ExistenciaRecursosSim.ExistenciaRecursosDt"
        [ngModelOptions]="{standalone: true}" inputStyleClass="col-auto form-control" dataType="string"
        dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
      </p-calendar>
    </div>
    <hr />
    <div class="row">
      <div class="col-12">
        <div class="checkbox checbox-switch switch-primary">
          <label>
            <input [(ngModel)]="entidade.ExistenciaRecursosSim.opcoes.OutrasFontesDescricao"
              [ngModelOptions]="{standalone: true}" type="checkbox" />
            <span></span>
            OUTRAS FONTES DE RECURSOS
          </label>
        </div>
        <div class="mb-3" *ngIf="entidade.ExistenciaRecursosSim.opcoes.OutrasFontesDescricao">
          <textarea [(ngModel)]="entidade.ExistenciaRecursosSim.OutrasFontesDescricao"
            [ngModelOptions]="{standalone: true}" class="form-control" rows="3"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="checkbox checbox-switch switch-primary">
          <label>
            <input [(ngModel)]="entidade.ExistenciaRecursosSim.opcoes.EmendasParlamentaresIndividuais"
              [ngModelOptions]="{standalone: true}" type="checkbox" />
            <span></span>
            EMENDAS PARLAMENTARES INDIVIDUAIS
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="checkbox checbox-switch switch-primary">
          <label>
            <input [(ngModel)]="entidade.ExistenciaRecursosSim.opcoes.Tesouro" [ngModelOptions]="{standalone: true}"
              type="checkbox" />
            <span></span>
            TESOURO
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="checkbox checbox-switch switch-primary">
          <label>
            <input [(ngModel)]="entidade.ExistenciaRecursosSim.opcoes.TransferenciasConveniosEstaduais"
              [ngModelOptions]="{standalone: true}" type="checkbox" />
            <span></span>
            TRANSFERÊNCIAS E CONVÊNIOS ESTADUAIS-VINCULADOS
          </label>
        </div>
        <div class="mb-3" *ngIf="entidade.ExistenciaRecursosSim.opcoes.TransferenciasConveniosEstaduais">
          <lib-licitacao-audesp-convenio-est [recurso]="entidade.ExistenciaRecursosSim">
          </lib-licitacao-audesp-convenio-est>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="checkbox checbox-switch switch-primary">
          <label>
            <input [(ngModel)]="entidade.ExistenciaRecursosSim.opcoes.RecursosPropriosFundosEspeciais"
              [ngModelOptions]="{standalone: true}" type="checkbox" />
            <span></span>
            RECURSOS PRÓPRIOS DE FUNDOS ESPECIAIS DE DESPESA-VINCULADOS
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="checkbox checbox-switch switch-primary">
          <label>
            <input [(ngModel)]="entidade.ExistenciaRecursosSim.opcoes.RecursosPropriosAdministracaoIndireta"
              [ngModelOptions]="{standalone: true}" type="checkbox" />
            <span></span>
            RECURSOS PRÓPRIOS DA ADMINISTRAÇÃO INDIRETA
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="checkbox checbox-switch switch-primary">
          <label>
            <input [(ngModel)]="entidade.ExistenciaRecursosSim.opcoes.ConvenioFederal"
              [ngModelOptions]="{standalone: true}" type="checkbox" />
            <span></span>
            TRANSFERÊNCIAS E CONVÊNIOS FEDERAIS-VINCULADOS
          </label>
        </div>
        <div class="mb-3" *ngIf="entidade.ExistenciaRecursosSim.opcoes.ConvenioFederal">
          <lib-licitacao-audesp-convenio-fed [recurso]="entidade.ExistenciaRecursosSim">
          </lib-licitacao-audesp-convenio-fed>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="checkbox checbox-switch switch-primary">
          <label>
            <input [(ngModel)]="entidade.ExistenciaRecursosSim.opcoes.OperacoesCredito"
              [ngModelOptions]="{standalone: true}" type="checkbox" />
            <span></span>
            OPERAÇÕES DE CRÉDITO
          </label>
        </div>
        <div class="mb-3" *ngIf="entidade.ExistenciaRecursosSim.opcoes.OperacoesCredito">
          <lib-licitacao-audesp-financiamento [recurso]="entidade.ExistenciaRecursosSim">
          </lib-licitacao-audesp-financiamento>
        </div>
      </div>
    </div>
  </p-fieldset>
</p-fieldset>